// The difficulty tiers offered for a Computer player, shared between the
// setup screen's dropdown (app.js) and whichever game controller actually
// simulates a CPU player's throws (currently just 501/x01 - see
// games/shared/x01-ai.js) - the id is what gets persisted (see
// savePlayersToStorage/loadPlayersFromStorage in db.js), the label/
// description are what the dropdown shows, and `throwProfile` is what a
// throw simulation actually reads.
//
// `throwProfile` is deliberately a named-field object, not positional
// arguments, and every reader of it (core/ai-throw-simulator.js today)
// treats a missing field as "this behavior doesn't apply" rather than
// requiring every field to be present - so it can grow later (a systematic
// aim bias, a pressure multiplier for a clutch dart, a chance of a
// deliberately imperfect target choice) without changing these tiers' shape
// or touching any existing caller. For now, by design, it's just
// `accuracyStdDev`: how far off-target (in dartboard.svg's own viewBox
// units - see core/dartboard-geometry.js's RADII for the scale: e.g. the
// treble ring is a 25-unit-wide band around radius ~125) a dart lands, on
// average, from a Gaussian scatter around the aim point. Smaller is more
// accurate. These five values are a first-pass tuning by feel (Expert
// should reliably find trebles/doubles, Beginner should scatter across
// neighboring wedges and rings), not derived from real player statistics -
// adjust freely.
// `description` is the dropdown's own (roomier) trait text; `shortDescription`
// is the same idea trimmed to one line, for anywhere a tier's trait is shown
// next to other detail already competing for space - a Computer player's row
// card on the setup screen, today.
export const DIFFICULTY_TIERS = [
    { id: 'beginner', label: 'Beginner', description: "Struggles with anything smaller than a single - the double and the bull are mostly luck.", shortDescription: 'Struggles with anything smaller than a single.', throwProfile: { accuracyStdDev: 83 } },
    { id: 'novice', label: 'Novice', description: 'Finds singles without trouble, but trebles and doubles still miss more often than not.', shortDescription: 'Finds singles reliably; doubles and trebles are hit or miss.', throwProfile: { accuracyStdDev: 45 } },
    { id: 'intermediate', label: 'Intermediate', description: 'Lands trebles and doubles about half the time.', shortDescription: 'Lands trebles and doubles about half the time.', throwProfile: { accuracyStdDev: 30 } },
    { id: 'advanced', label: 'Advanced', description: 'Rarely misses the segment it aims for, including outer doubles and awkward trebles.', shortDescription: "Rarely misses the segment it's aiming for.", throwProfile: { accuracyStdDev: 21 } },
    { id: 'pro', label: 'Pro', description: 'Plays like a pro - trebles, doubles and the bull are all routine.', shortDescription: 'Plays like a pro - misses are rare.', throwProfile: { accuracyStdDev: 15.3 } }
];

export const DEFAULT_DIFFICULTY = 'intermediate';

export function findDifficultyTier(id) {
    return DIFFICULTY_TIERS.find(t => t.id === id) || DIFFICULTY_TIERS.find(t => t.id === DEFAULT_DIFFICULTY);
}
